import { useEffect } from 'react';

import { useCurrentReviewerAccount } from 'src/store/user/useCurrentReviewerAccount';
// @ts-expect-error - no TypeScript definitions yet
import { useInviteAcceptPopup } from 'src/views/InviteSubmitPopup';

import { ReviewerDashboardPage } from './ReviewerDashboardPage';
import { StoreContainer } from './store';

export const Container = () => {
  const account = useCurrentReviewerAccount();
  // An invite link of a signed-in user lands here, as it lands on the full user's home page.
  const showInviteAcceptModalIfNeeded = useInviteAcceptPopup();

  useEffect(() => {
    showInviteAcceptModalIfNeeded();
  }, [showInviteAcceptModalIfNeeded]);

  if (!account) {
    return null;
  }

  return (
    // Another reviewer account has its own list.
    <StoreContainer
      key={account.id}
      customerId={String(account.id)}
    >
      <ReviewerDashboardPage accountName={account.name} />
    </StoreContainer>
  );
};
